import { useContext } from 'react'
import { FlexBox, Text } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { SearchContext } from 'state'

const SearchbarFilters = () => {
  const { setActiveFilter, filters, activeFilter } = useContext(SearchContext)
  const { nativeOverrides, colors } = useTheme()

  return (
    <FlexBox
      alignItems="center"
      className={css`
        flex: 0 0 auto;
        gap: 24px;
        margin: 0px 24px 24px 24px;
        border-bottom: 1px solid ${colors.whiteSmoke};
        width: 100%;
        max-width: 876px;
        @media only screen and (min-width: 900px) {
          margin: 0 auto;
        }
      `}
    >
      {filters?.map((type) => (
        <button
          type="button"
          onClick={() => setActiveFilter(type.key)}
          className={cx(
            nativeOverrides.buttonClear,
            'filter',
            css`
              padding: 18px;
              &.filter,
              * {
                cursor: pointer;
              }
              &.filter,
              &.filter:hover {
                border-bottom: 3px solid transparent;
              }
            `,
            activeFilter === type.key &&
              css`
                &.filter,
                &.filter:hover {
                  border-bottom: 3px solid ${colors.graphite};
                }
              `
          )}
          key={type.key}
        >
          <Text
            color={
              activeFilter === type.key
                ? colors.graphite
                : colors.pewterGreyDark
            }
            type="subhead"
            sizing="XS"
            text={type.title}
          />
        </button>
      ))}
    </FlexBox>
  )
}

export default SearchbarFilters
